import { useEffect, useRef } from 'react';
import { track, identify } from '@/lib/analytics';
import { useProfileStore } from '@/lib/state/profile-store';

/**
 * Fires `screen_view` on mount and `identify()` if user is logged in.
 * Use at the top of every screen component.
 */
export function useTrackScreen(screen: string): void {
  const user = useProfileStore((s) => s.user);
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;

    if (user?.id) {
      identify(user.id);
    }
    track('screen_view', { screen });
  }, [screen, user?.id]);
}
